import { render, staticRenderFns } from "./GumroadSales.vue?vue&type=template&id=72912397&"
import script from "./GumroadSales.vue?vue&type=script&lang=js&"
export * from "./GumroadSales.vue?vue&type=script&lang=js&"
import style0 from "./GumroadSales.vue?vue&type=style&index=0&id=72912397&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports